<template>
  <v-bottom-navigation
    class="bottom-nav"
    background-color="primary"
    grow
    v-if="$_isAppInstalled || $vuetify.breakpoint.xs"
  >
    <v-btn @click="$router.go(-1)">
      <span class="white-text">Bakåt</span>

      <v-icon color="white">mdi-arrow-left</v-icon>
    </v-btn>

    <v-btn @click="$router.push({ name: 'Home' })">
      <span class="white-text">Hem</span>

      <v-icon color="white">mdi-home</v-icon>
    </v-btn>
    <GeoSelect />
  </v-bottom-navigation>
</template>

<script>
import Misc from '@/mixins/Misc.js'
import GeoSelect from '@/components/GeoSelectBottom.vue'

export default {
  name: 'BottomNav',
  mixins: [Misc],
  components: {
    GeoSelect
  },
  methods: {
    setGeo() {
      this.$store.dispatch('setGeoLocation')
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
}
.white-text {
  color: white;
}
</style>
